module.exports = __webpack_public_path__ + "img/JFP00905-2.5cd6ba80.jpg";